import React, { useEffect, useState } from "react";
import SubjectSelection from "./SubjectSelection";
import ClassSelection from "./ClassSelection";
import ChapterSelection from "./ChapterSelection";
import QuestionPaper from "./QuestionPaper";

const MainComponent = ({setPrintContent}) => {
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");

  const handleSubjectSelected = (subject) => {
    setSelectedSubject(subject);
    setSelectedClass("");
    setSelectedChapter("");
  };

  const handleClassSelected = (selectedClass) => {
    setSelectedClass(selectedClass);
    setSelectedChapter("");
  };

  const handleChapterSelected = (selectedChapter) => {
    setSelectedChapter(selectedChapter);
  };

  useEffect(() => {
    // console.log(selectedSubject)
    // console.log(selectedClass)
    // console.log(selectedChapter)
  }, [selectedSubject]);

  return (
    <div className="App p-5 min-h-screen bg-gradient-to-br from-blue-200 via-white to-red-100 font-normal">
      <h1 className="text-center m-4 text-black-800 font-semibold text-4xl font-mono text-blue-900">Test Generator App</h1>
      <SubjectSelection  setPrintContent={setPrintContent}
        onSubjectSelected={handleSubjectSelected}
        selectedSubject={selectedSubject}
      />
      {selectedSubject && (
        <>
          <ClassSelection  setPrintContent={setPrintContent}
            selectedSubject={selectedSubject}
            selectedClass={selectedClass}
            onClassSelected={handleClassSelected}
          />
          {selectedClass && (
            <>
              <ChapterSelection  setPrintContent={setPrintContent}
                selectedSubject={selectedSubject}
                selectedClass={selectedClass}
                selectedChapter={selectedChapter}
                onChapterSelected={handleChapterSelected}
              />
              {selectedChapter && (
                <QuestionPaper  setPrintContent={setPrintContent}
                  selectedSubject={selectedSubject}
                  selectedClass={selectedClass}
                  selectedChapter={selectedChapter}
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default MainComponent;
